module.exports = __webpack_public_path__ + "static/media/as_item2_content.6eeb9e82.png";